import { GridValidRowModel } from "@mui/x-data-grid";
import { FieldValues } from "react-hook-form";
import { UseItecDataGrid, UseItecDataGridProps, dataGridBase } from "./base";
import {
  UseItecDataGridPaginatedProps,
  UseItecDataGridPaginated,
  dataGridPaginated,
} from "./paginated";

// function useItecDataGrid<
//   Paginated extends boolean = false,
//   Filterable extends boolean = false,
//   Sortable extends boolean = false,
//   Selectable extends boolean = false,
//   TEntity extends GridValidRowModel,
//   TFilter extends FieldValues = {}
// >(
//   props: UseItecDataGridPaginatedProps<TEntity, TFilter>
// ): UseItecDataGrid<TEntity>;

function useItecDataGrid<
  TEntity extends GridValidRowModel,
  TFilter extends FieldValues = {}
>(
  props: UseItecDataGridPaginatedProps<TEntity, TFilter>
): UseItecDataGrid<TEntity, TFilter>;

function useItecDataGrid<
  TEntity extends GridValidRowModel,
  TFilter extends FieldValues = {}
>(
  props: UseItecDataGridProps<TEntity, TFilter>
): UseItecDataGridPaginated<TEntity, TFilter>;

function useItecDataGrid<
  TEntity extends GridValidRowModel,
  TFilter extends FieldValues = {}
>(
  props:
    | UseItecDataGridProps<TEntity, TFilter>
    | UseItecDataGridPaginatedProps<TEntity, TFilter>
):
  | UseItecDataGrid<TEntity, TFilter>
  | UseItecDataGridPaginated<TEntity, TFilter> {
  if (props.pagination) {
    return dataGridPaginated<TEntity, TFilter>(props);
  }

  return dataGridBase<TEntity, TFilter>(props);
}

export default useItecDataGrid;
